import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { ROUTES } from "../../../../../routes";
import { IAsyncData } from "../../../../../core/models";
import { IFloor } from "../../data/entities";
// import { theme } from "../../../../../../theme/variables";

const Title = styled.h4`
  text-align: center;
  margin: 0.5rem 0 0;
  line-height: 1.3;

  @media screen and (max-width: 1300px) {
    margin: 0.25rem 0 0;
  }
`;

const FloorNumber = styled.span`
  font-size: 1.1rem;
  font-weight: 700;
  color: white;
`;

const FloorControl = styled.a`
  cursor: pointer;
  font-size: 0.85rem;
  color: rgba(255, 255, 255, 0.5);
  transition: 0.2s color ease;

  :hover,
  :focus {
    color: white;
  }
`;

interface IProps {
  floorDetailBranch: IAsyncData<IFloor>;
  projectId: string;
  sectorId: string;
  onPageChange: (params: any) => void;
}

export const FloorTopNav: React.FC<IProps> = ({ floorDetailBranch, projectId, sectorId, onPageChange }: IProps) => {
  const prevFloorId = floorDetailBranch.data?.prevFloorId;
  const nextFloorId = floorDetailBranch.data?.nextFloorId;

  return (
    <Title>
      {prevFloorId && (
        <FloorControl
          onClick={() => onPageChange({
            route: ROUTES.floor,
            param1: projectId,
            param2: sectorId,
            param3: prevFloorId,
          })}>
          {`Mərtəbə ${floorDetailBranch.data?.prevFloorNumber} < `}
        </FloorControl>
      )}

      <FloorNumber>{` Mərtəbə ${floorDetailBranch.data?.number} `}</FloorNumber>

      {nextFloorId && (
        <FloorControl
          onClick={() => onPageChange({
            route: ROUTES.floor,
            param1: projectId,
            param2: sectorId,
            param3: nextFloorId,
          })}>
          {` > Mərtəbə ${floorDetailBranch.data?.nextFloorNumber}`}
        </FloorControl>
      )}
    </Title>
  );
};
